import images from "./images";

const testimonials = [
    {
        id: 1,
        image: images.testimonial1,
        name: 'James Anderson',
        title: 'Coffee Lover',
        rating: 5,
        content: 'I love the cozy vibe of Brewtopia! The coffee is always freshly brewed, and the staff is friendly and knowledgeable. The latte art is a real treat too!',
    },
    {
        id: 2,
        image: images.testimonial2,
        name: 'Emily Johnson',
        title: 'Business Owner',
        rating: 5,
        content: 'Brewtopia is my go-to place for meetings and catching up with friends. The coffee is always exceptional, and the atmosphere is perfect for a productive day.',
    },
    {
        id: 3,
        image: images.testimonial3,
        name: 'Michael Bennett',
        title: 'Frequent Visitor',
        rating: 5,
        content: 'The best espresso in town! Brewtopia never disappoints. Whether it\'s a quick cup on my way to work or relaxing day with friends, it\'s always a great experience.',
    },
    {
        id: 4,
        image: images.testimonial4,
        name: 'Sarah Miller',
        title: 'Local Resident',
        rating: 5,
        content: 'I love Brewtopia’s unique seasonal flavors and the friendly atmosphere. The baristas know exactly how I like my coffee, and it’s always perfect. A must-visit!',
    },
];

export default testimonials;